export default {
    language:'日本語',
	sanqi: {
		zhoushi: "トレンド図",
		biaoti: "高流動性市場における暗号化通貨取引",
		xiangqing: "長年の運営経験は、ユーザーに豊富で、柔軟で、安定で、安全で信頼できる取引環境を提供した。",
		Global: "グローバルエコレイアウト",
		Bank: "銀行レベルのセキュリティ",
		Focus: "ユーザーエクスペリエンスに注目",
		Convenient: "便利な取引",
		project: "グローバルプロジェクトの拡張と運営管理システムは、多くの国にローカルサービス貿易センターを設置している。",
		level: "銀行級財布システム、リアルタイム金融リスクコントロールと多次元認証、金融安全チームは過去10年間、資金安全に多重保障を提供した。",
		polish: "細部を細かく磨き、UIとインタラクションを段階的に快適にし、取引を視覚的に楽しむことができます。",
		Android: "Android、IOS、webの3つの端末の操作をサポートして、いつでもどこでもリアルタイムで市場情報、全世界の市場と取引を制御します",
		Download: "モバイルクライアントをダウンロードし、いつでもどこでも自由に取引できます。",
		Palm: "パーム取引",
		Trade: "いつでもどこでも取引",
		flow: "流動体験",
		Smooth: "スムーズな操作により、より快適な体験ができます。",
		Real: "リアルタイム見積り",
		time: "リアルタイムの更新により、市場のトレンドを把握",
		Rapid: "クイックチャージ",
		Experience: "素早く体験して、あなたが望むものを楽しんでください。",
		Join: "契約の旅を始める",
		Please: "下記の入力ボックスに携帯電話/電子メールを入力してAzbit-usaに登録してください",
		enter: "メールまたは携帯電話番号を入力してください",
		Register: "登録する",

		regulatory:'規制ライセンス',
		regulatory_info:'Uncleblock は、カナダの FINTRAC (カナダ金融取引および報告分析センター) および米国 SEC (米国証券取引委員会) の監督下にある、法的に準拠した金融および金融サービス会社です。 Uncleblock は、金融ライセンスの取得に基づいて、事業を展開する各法域で適用されるすべての法律および規制を遵守します。 ',
		canada:'カナダ (監督下)',
		certnum:'規制認証番号',
		dateissue:'発行日',
		veriurl:'カナダの検証 URL',
		
		white_paper: '白書',
	},
	song: {
		low:'古いパスワードを入力してください',
	    jgsxf:"極速契約による注文控除手数料",
	    jgbj:"極速契約で元金を差し引く",
	    jgks:"極速契約注文、損失決算",
	    jgyl:"極速契約注文平倉、利益決算",
	    htcz:"バックグラウンドチャージ",
	    htshcz:"バックグラウンド審査チャージ",
	    bbhr:"貨幣の口座を切り込みます",
	    bbhc:"貨幣の口座から割り出す",
	    pccl:"平倉資金処理",
	    gmsxf:"掛け売り控除手数料",
	    ggsxf:"レバー取引の提出、手数料の控除",
	    ggbzj:"レバー取引を提出し、保証金を控除する。",
	    gbdj:"買い止めを提出する",
	    gbkc:"掛け買い控除をかける",
	    gsdj:"売り掛けの凍結を提出する",
	    gskc:"掛け売り控除をかける",
	    tbsbjs:"貨幣の引き出しに失敗して、ロック残高が減少しました。",
	    tbsbch:"貨幣の引き出しに失敗しました。ロック残高は撤回しました。",
	    tbcg:"お札の引き出しに成功しました",
	    gyf:"レバレッジ取引で、夜間料金がかかります。",
	    gghr:"てこの口座に振り込む",
	    gghc:"レバー口座から振り出す",
	    tbdj:"貨幣の凍結残高を申請します。",
	    tbkc:"お引き出しの残高を申請します。",
	    mhxh:"ブラインドボックスの消耗",
	    mhhq:"ブラインドボックス取得",
	    msxf:"秒契約の注文は手数料を差し引きます。",
	    mbj:"秒契約の注文は元金を差し引きます。",
	    mks:"秒契約の注文書、損失決算",
	    myl:"秒契約書の注文を確定し、利益を決算する。",
	    mhr:"秒契約口座に振り込む",
	    mhc:"秒契約口座から振り出す",
	    sfsczj:"ロックを解除して採掘可能資産を増加させる。",
	    sfsckc:"ロックポジションの採掘から凍結資産を控除する",
	    sczj:"ロックハウスで採掘し、凍結資産を増加させる。",
	    sckc:"ロックヤードで採掘可能資産を控除する",
	    scsy:"ロックヤードで採掘可能資産",
	    ahtcz:"バックグラウンドチャージコメント",
	    xcbx:"極速契約書の注文書は平倉で決済し、発効保険がなく、資金は変わらない。",
		bbjx:"貨幣取引：ユーザーが予約をキャンセルしてロックを解除する",
		bbth:"貨幣取引：ユーザーが買い戻しをキャンセルする",
		wtcd_t:"キャンセルを依頼して、手数料を払い戻す。",
		wtcd_b:"差し引きを委託して保証金を戻す",
		bxju_p:"保険解約、賠償金",
		bxju_s:"保険解約、保険料控除",
		bxju_b:"保険解約、保険金額控除",
	},
	iesan: {
		li_a: '集中してください。他のものは私たちに任せてください。',
		li_b: '自動化投資分析――Azbit-usaのロックハウス採掘によって、投資者の主要取引通貨にカスタマイズされた取引構想の高度自主化口座に設定することができます。市場上の異なるリスク耐える能力を全面的に考慮するトレーダー。予約口座のお金を借ります。プラットフォームはロックハウスの採掘予約のお金を提供します。口座のデジタル資産が予約限度の50%に達するだけで、申請すればプラットフォームの融資のお金を借りることができます。',
		zuidi: '最低投稿数',
		b_liord: "ブラインドケース注文",
		b_zhomg: "盲箱が当たる",
		b_xiaohao: "消耗する",
		b_mangheli: "ブラインドバッグ",
		b_qingsong: "簡単にスーパーバッグを発掘します。",
		b_kaiqi: "ブラインドボックスを開く",
		b_xuyao: "現在のブラインドボックスを開くには必要です。",
		b_dangqian: "現在残高",
		b_quxiao: "キャンセル",
		b_ok: "を選択します",
		b_cuocang: "倉庫をロックして貨幣を稼ぐ",
		b_dindan: "ブラインドケース注文",
		b_genduo: "もっとロード",
		b_wabao: "宝を掘る",
		b_jiandan: "採掘はもっと簡単で、ご褒美がもらえます。",
		b_cung: "倉庫をロックして貨幣を稼ぐ",
		b_shouyi: "総収益",
		b_zhiyao: "質権設定数量",
		b_qianbao: "財布の残高",
		b_goumai: "買います",
		b_zhjuanbi: "倉庫をロックして貨幣を稼ぐ",
		b_num: "貨幣の数",
		b_yuji: "総利益を見込む",
		b_jin: "近い",
		b_rinianhua: "日を参考に年化",
		b_suochang: "ロック期限",
		b_gtou: "買います",
		b_jilu: "ロック記録",
		b_biaohuao: "項目番号",
		b_bizhong: "貨幣種類",
		b_shuliang: "貨幣の数",
		b_jixi: "総利息",
		b_suocang: "ロック時間",
		b_shijan: "締切時間",
		b_zhuangtai: "状態",
		b_jinxin: "進行中",
		b_jieshu: "終了しました",
		b_zhenqui: "正しい数量を入力してください。",
		b_tian: "空",
		b_mei: "これ以上ないです",
		b_maghe: "ブラインドケース",
		b_wakuang: 'ロック穴',
		levermin: "取引数量が最小取引数より小さい"
	},
	chongbi: {
		zaixian:"オンラインサービス",
		fuzhi:"ラベルをコピー",
		huazhuan:"振り回す",
		bizhong:"貨幣種類",
		keyong:"利用可能残高",
		cong:"から",
		zhi:"至を選択します",
		num:"数量を振り替える",
		shuru:"振り替え数量を入力してください。",
		whatsapp:"入力してください whatsapp アカウント",
		youxiang:"メールボックス",
		superior: '私の部下',
		tiem: '時間',
		tit: '私の会員',
		group: 'チームの人数',
		not: '会員はまだいません',
		qukuai: 'ブロックチェーン学校',
		fabi: '仏貨取引',
		gonggao: '公告する',
		xitong: 'システム記事',
		yonghu: 'ユーザーサポート',
		bangzhu: 'ヘルプセンター',
		shouyi: '収益ルール',
		xinwen: 'ニュース？センター',
		xinshou: 'ニュース？センター',
		jiaoyi: '取引のルール',
		kuaixun: '速報',
	},
    // ナビゲーション
    header:{
		wakuang: 'ロック穴',
		miaohy:'極速契約',
        home:'トップページ',
        markets:'相場',
        fiat:'法定通貨取引',
        c2c:'C2C取引',
        exchange:'現物取引',
        lever:'レバレッジ',
        myshop:"私の店舗",
        assets:'私の資産',
        help:'ヘルプセンター',
        login:"ログイン",
        sign:'登録',
        accountSet:'アカウント設定',
        tradeLog:'取引日にち',
        receiveSet:'入金設定',
        identify:'身分認証',
        jchange:'両替します',
        logout:'ログアウト',
        themedark:'ナイトモード',
        themeday:'昼間モード',
    },
    // 登录注册
    lg:{
        login:'ログイン',
        register:'登録',
    },
    // 首页
    home:{
        vol:'24H取引量',
        c01:'世界でリードしているデジタル資産取引プラットフォーム',
        c02:'130カ国を超える数百万のユーザーのために、信頼できるデジタル資産取引及び資産管理サービスを提供しています。',
        c03:'安全で信頼できます',
        c04:'5年間の暗号資産金融サービスの経験',
        c05:'専門的な分散システムとDDOS攻撃防止システム',
        c06:'世界の生態配置',
        c07:'複数の国で現地化取引サービスセンターを設立しています',
        c08:'多業務形態を一体とするブロックチェーンのグローバル展開を推進します',
        c09:'ユーザー至上',
        c10:'先行賠償支払い機制を設立します',
        c11:'投資者保護基金を設立します',
        c12:'いつでもどこでもマルチプラットフォーム端末取引',
        c13:'iOS、Android、Windowsのプラットフォームを覆い,全業務機能をサポートします',
        sweep:'ダウンロード',
        android:'Android',
        pinput:'お手数でございますが、メールアドレスか携帯番号をご入力してください',
        atrade:'Azbit-usaのアカウントを登録してから、取引を開始致します'
    },
    // 底
    foo:{
        about:'私たちに関して',
        support:'ユーザーサポート',
        contact:'連絡先',
        qq:'担当者QQ',
        email:'メールアドレス',
    },
    // 相場
    market:{
        exchange:'貨幣',
        selfmarket:'自選',
        allmarket:'総相場',
        symbol:'取引対',
        newprice:'最新価格',
        change:'上げ幅',
        highprice:'最高値',
        lowprice:'最低価',
        vol:'24H 取引量',
    },
    // 公共取引
    td:{
		purchase: "買い入れ価格",
		transaction: "出来値",
		service: "手数料",
		profit: "利益と損失",
        buy:'購入',
        sell:'売却',
        currency:'幣種',
        num:'数量',
        time:'時間',
        limit:'限度額',
        price:'単価',
        method:'支払い方式',
        total:'総額',
        inwant:'ご入力の、、、',
        do:'操作',
        more:'ローディング',
        nomore:'以上',
        nodata:'データなし',
        trade:'取引',
        buynum:'購入数量',
        sellout:'売出す',
        buyin:'購入',
        all:'すべて',
        allbuy:'全部買い取り',
        allsell:'全部売り出し',
        buytotal:'購入総額を入力してください',
        selltotal:'売却総額を入力してください',
        buyallnum:'購入希望数量を入力してください',
        sellallnum:'売出す数量を入力してください',
        tradeTotal:'取引総額',
        doceil:'数秒後自動キャンセル',
        place:'注文する',
        waitpay:'支払いを待つ',
        paycode:'支払いコード',
        finished:'完成',
        ceiled:'キャンセル',
        payed:'支払済み',
        nofinish:'未完成',
        buyer:'買い手',
        seller:'売り手',
        callWay:'連絡方法',
        placeTime:'注文時間',
        renum:'参考番号',
        canceil:'キャンセル',
        confirm:'確認',
        pwd:'取引のパスワード',
        coincode:'通貨単位',
        pcoin:'通貨単位を選択してください'
    },
    // 法定通貨取引
    fat:{
        // LegalPayDetail
        orderLog:'注文登録',
        fatdLog:'法定通貨取引記録',
        shoper:'売買主',
        faLog:'法定通貨取引記録',
        tdType:'取引種類',
        odStatus:'注文状態',
        pwaitPay:'お手数ですが、買い手の支払いしばらくお待ちください。',
        odFinish:'注文完了',
        odCeil:'注文キャンセル',
        odPay:'お支払いになりましたので、支払いの情報をよくチェックしてください',
        tdCeil:'取引をキャンセル',
        pCeil:'もし売り手に金額を支払った場合、決して取引をキャンセルしないでください',
        paySure:'支払い確認',
        pdopay:'お手数ですが、売り手へのお支払いをご確認してください',
        badClick:'悪質なクリックは直接口座を凍結します',
        receivePay:'入金確認',
        payReceive:'お手数ですが、購入者のお支払いをご確認してください',
        receivePays:'入金確認完了',
        // LegalPay
        payPlease:'お手数ですが、お支払いお願い致します',
        tdPrice:'取引単価',
        tdNum:'取引数量',
        payinfo:'支払い状況',
        banknum:'銀行口座',
        realName:'実名',
        shoperZname:'売買主支店',
        shoperNum:'売買主アカウント',
        odCeil:'注文キャンセル',
        imPay:'お支払い済み、クリックしてご確認してください',
        // LegalSeller
        register_time:'登録時間',
        odtotal:'総計リスト',
        odmonth:'30日間完成リスト',
        odfinish:'完成リスト',
        odrate:'完成率',
        submit:'発表',
        phone:'携帯電話',
        mysell:'売却',
        mybuy:'仕入れ',
        realAuth:'実名認証',
        advAuth:'高級認証',
        linebuy:'オンライン購入',
        linesell:'オンライン売出す',
        tipPay:'24時間を超えると自動的にキャンセルするため、24時間以内に業者と連絡を取ってください',
        notlow:'最低限度額を下回ることはできません',
        nothigh:'最大限度額を超えてはいけません',
        notnum:'最大数量を超えてはいけません',
        // LegalShopDetail
        type:'タイプ',
        status:'状態',
        seeOrder:'注文書をチェック',
        withdraw:'撤回',
        abnormal:'異常',
        lowershelf:'棚をおりる',
        protection:'権力を擁護',
		apply:'権利の主張',
        psType:'お手数ですが、タイプを選択してください',
        pselect:'お手数ですが、選択してください',
        alipay:'支付宝',
        wechat:'WeChat',
        bank:'銀行カード',
        minNum:'最小取付け量',
        maxNum:'最大取引量',
        wantBuy:'仕入れ',
        pnums:'数量を入力してください',
        pmin:'最小取引量を入力してください',
        pmax:'最大取引量を入力してください',
        pnot:'最大取引量が最小取引量より小さいことはできません',
        // MyLegalShops
        myshops:'店舗',
        name:'名称',
        fiatSub:'法定貨幣属する',
        shoper_balance:'売買主し残高',
        enterShop:'入店',
        // shop_legal_pay_detail
        payedWait:'お支払い済み、ご確認お願い致します',
        yes:'はい',
		no:'いいえ',
		sd:'残高をロックする',
		journal:'残高ログ',
		business:'商売人',
		user:'ユーザー',
        backdone:'取り下げ済み',
        busbalance:'事業者残高',
		userbalance:'ユーザー残高',
    },
    ctc:{
        ctc:'C2C',
        myRelease:'発表したC2C',
        myTrade:'取引したC2C',
        and:'正確',
        balance:'残高',
        buynum:'買い入れ量',
        sellnum:'販売量',
        bankTransfer:'銀行振替',
        payim:'必ず本人が支払わなければなりません',
        pbuyNum:'お手数ですが、購入数量をご入力してください',
        pprice:'お手数ですが、単価をご入力してください',
        payway:'お手数ですが、お支払い方法を選択してください',
        psellNum:'お手数ですが、販売数を入力してください',
        suerePlace:'ご注文確認お願いいたします?',
        detail:'詳細',
        payinfo:'お支払い情報',
        Payee:'受取人',
        total:'総額',
        name:'名前',
        cardnum:'カード番号',
        receivePay:'入金確認',
        ceilConfirm:'取引キャンセル確認？',
        paySeller:'お手数ですが、販売者へのお支払いをご確認し悪質なクリックがございましたら直接口座を凍結されます',
        payBuyer:'お手数ですが、購入者からの情報をご確認してください',
        account:'アカウント',
        sellerPay:'お手数ですが、販売者からのお支払いをご確認してください？',
        payattion:'お手数ですが、お支払いの確認後は早めに売り手にお支払いください。悪意のあるクリックは口座を冻结されます',
        log:'c2c已完成订单'
    },
    // てこ
    lever:{
		purchase: "買い入れ価格",
		Expected: "損益を予想する",
		countdown: "カウントダウン",
		second: "秒",
		jiaoyinum:"量",
		houmaicg:"購入の成功",
        nowentrust:'ご依頼',
        hisentrust:'履歴依頼',
        lvchi:'てこ倉位持ち有り',
        all:'全部',
        or:'或いは',
        gotrade:'取引開始',
        tdrecord:'取引記録',
        dealed:'成約',
        notdeal:'未成約',
        loading:'ローディング中',
        entotal:'委託総額',
        canuse:'マーケティング取引価格',
        std:'マーケティング取引価格',
        xtd:'限定取引価格',
        pprice:'お手数ですが、価格をご入力してください',
        phand:'購入数量を入力してください。',
        phandsell:'販売数量を入力してください。',
        pwd:'パスワード',
        ppwd:'取引パスワードを入力してください',
        psw:'取引のパスワード',
        equal:'等しい',
        times:'倍',
		miaos:'秒',
        timed:'倍数',
        hand:'一株',
		miao:'s',
        hands:'',
        ptimes:'お手数ですが、倍数をご選択してください',
        phands:'お手数ですが、一株当たりをご選択してください',
        contractVal:'契約マーケティング値',
        bail:'保証金',
        canBail:'有効保証金',
        charge:'取引サービス料',
        domore:'買い取る（多め）',
        doshort:'売却（空っぽ）',
        dmore:'多め',
        dshort:'空っぽ',
        sureOd:'ご注文を確認致します',
        noless:'一株当たり、、、下回ることはできません',
        nomore:'一株当たり、、、上回ることはできません',
        tdnum:'取引量',
        risk:'リスク率',
        allloss:'倉庫を持って総損益',
        onehouse:'クリック平倉',
        type:'タイプ',
        entrustPrice:'委託価格',
        openPrice:'開倉価格',
        nowPrice:'現在の価格',
        styPrice:'黒字価格をとめる',
        stsPrice:'赤字価格を止める',
        openTime:'開倉時間',
        closeTime:'平倉時間',
        rate:'手数料',
        nightFee:'日越し費用',
        loss:'損益',
        setloss:'損益を防ぐため設置する',
        expectProfit:'黒字を予期する',
        expectLoss:'赤字を予期する',
        allClose:'全部平倉',
        moreClose:'ただ多めの片手を平らげます',
        nullClose:'先に売って平倉を購入します',
        sureClose:'平倉を確認する？',
        thanZearo:'設定する値は必ず0より大きい',
        listin:'掛け値中',
        tdin:'取引中',
        closein:'平倉中',
        closed:'すでに平倉',
        revoked:'取り消す',
        revokeOrder:'注文の取り消すことをご確認してください？',
        ping:'平倉',
        revoke:'撤退する',
        sureping:'平倉を確定しますか？',
        thanzone:'設定する値は0より大きい',

		profitability: '収益性',
		profit_: '利益',
    },
    // 貨幣
    cuy:{
        direction:'方向',
        total:'総計',
        price:'価格',
        sell:'売る',
        buy:'買う',
        allStation:'全般取引',
        buyPrice:'買入れ価格',
        buynum:'購入量',
        sellPrice:'売り値',
        sellnum:'販売量',
        tdPrice:'取引額',
        or:'或いは',
        tdStart:'取引開始',
        pbPrice:'お手数ですが、買入価格をご入力してください',
        pbNum:'お手数ですが、購入量をご入力してください',
        psPrice:'お手数ですが、売り値をご入力してください',
        psNum:'お手数ですが、販売量をご入力してください',
        fixPrice:'取引限定値',
        Mtrans:'取引マーケティング値',
        available:'利用可能',
        revoke:'撤回',
        loading:'ローディング中',
        confirmCancel:'キャンセルすることは確定しましたか?？',
        confirm:'確定',
        cancel:'キャンセル',
        nomore:'これ以上のデータはございません',
        evelPrice:'成約値'
    },
    // 資産
    asset:{
		text1:'チャージアドレス',
		text2:'チャージの住所を入力してください。',
		text3:'チャージの数',
		text4:'チャージの数を入力してください。',
		text5:'チャージ情報を提出する',
		miao_account: '極速契約口座',
        assets:'資産',
        currency_account:'貨幣口座',
        lever_account:'てこ口座',
        fince_account:'法定通貨取引口座',
        change_account:'取引口座',
        assets_hua:'資金分割移動',
        all_assets:'総資産の換算',
        currency:'弊種',
        canuse:'利用可能',
        frezz:'凍結',
        conversion:'換算',
        charging:'チャージ',
        withdraw:'キャッシュ',
        address_bind:'バンドルの住所',
        address_withdraw:'キャッシュアドレスの管理',
        record:'記録',
        address_charge:'チャージ口座',
        address_width:'提出貨幣口座',
        copy:'コーピ',
        ercode:'コード',
        reminder:'お知らせ',
        notcharge:'USDT以外の資産を上記のアドレスにリチャージしないでください。そうしないと、資産が取得されません',
        support:'チャージはsimple sendの方法だけをサポートしており、その他（send all）の方法でチャージしても一時的に振込できませんので、ご了承ください。',
        minnum:'最小限提出貨幣の数量',
        ratenum:'手数料',
        havenum:'着通帳数量',
        from:'から',
        to:'まで',
        transfer:'分割移動',
        tfnum:'分割移動数量',
        ptfnum:'请输入最低',
        dtfnum:'的划转数量',
        canbalance:'利用可能の残高',
        sureConfirm:'分割移動確認',
        moneyRecord:'財務記録',
        pNum:'お手数ですが、最低限の分割移動数量をご入力してください',
        leverUse:'てこの口座利用可能',
        legalUse:'法定通貨取引利用可能',
        changeUse:'取引口座の利用可能',
        look:'チェック',
        chargeRecord:'チャージ記録',
        status:'追跡状態',
        noopen:'この機能はしばらく開放されていません',
        enterAdderses:'お手数ですが、提出貨幣先をご入力してください',
        enterNum:'请输入提币数量',
        lessMin:'ご入力した提出貨幣数量は最小値より小さいです',
        tips01:'資産は上記のアドレスにチャージしないでください。さもなければ資産を取り戻すことはできません。',
        tips02:'チャージはsimple sendの方法だけをサポートしており、その他（send all）の方法でチャージしても一時的に振込できませんので、ご了承ください。',
        beizhu:'備考',
        pbeizhu:'お手数ですが、備考欄にご記入してください',
        add:'追加',
        addressList:'住所リスト',
        delete:'削除',
        norec:'記録なし',
        selectCurrency:'お手数ですが、貨幣種類を選択してください',
        chainType:"チェーンの種類"
    },
    // アカウント設定
    set:{
        mycode2:'私のライセンスコード',
        copycode2:'認証コードをコピー',
        uaccont:'アカウントのセキュリティレベル:',
        strong:'強',
        middle:'中',
        weak:'弱',
        min:'低',
        heigh:'高',
        complete:'より多くの資料を補充し、アカウントの安全性を高めることを保証します',
        mycode:'招待コード',
        copycode:'招待コードをコピー',
        bindphone:'バインディング携帯電話',
        bindemail:'バインディングメールアドレス',
        loginpwd:'ログインパスワード',
        noBind:'未バインディング',
        binds:'バインディング',
        bind:'バインディングを行う',
        binded:'バインディング完成',
        net:'インターネットのアカウントは盗まれるリスクが高いので、定期的にパスワードを変更してアカウントの安全を保護することをお勧めします。',
        reset:'修正',
        setPsw:'取引のパスワードを設定し、取引安全を保障する。',
        goSet:'設定を行う',
        bindAccount:'バインディング振り替えアカウント',
        duihuan:'バインディングアカウントでポイント交換を行います',
        copysuccess:'コピー成功',
        copyfail:'コピー失敗',
        recopy:'お手数ですが、再度コピーしてください',
        account:'アカウン',
        detail:'詳細',
        val:'金額',
        forgetPsw:'パスワードを忘れる',
        code:'検証コード',
        getCode:'送信する',
        setPsw:'パスワードを設定',
        enterPsw:'お手数ですが、パスワードをご入力してください',
        pswFalse:'お手数ですが、二度ご入力したパスワードは一致しません',
        enterPswagain:'お手数ですが、パスワードを再度ご入力してください',
        jsetPsw:'取引のパスワードを設定',
        jenterPsw:'取引のパスワードを入力してください。',
        jenterPswagain:'取引のパスワードをもう一度入力してください。',
        enterAccount:'お手数ですが、アカウントをご入力してください',
        enterCode:'お手数ですが、検証コードをご入力してください',
        accountFalse:'すみませんですが、ご入力した携帯番号やメールアドレスは不規則でございます!',
        second:'秒',
        sendCode:'送信する',
        sendsucc:'送信成功',
        enterPswTwo:'お手数ですが、パスワードを2回ご入力してください',
        rest:'残り',
        yes: 'はい、',
        no: 'いいえ、',
        yorn: '取引パスワードを設定するかどうか',
    },
    // 身分認証
    auth:{
        identity:'身分認証',
        name:'名前',
        idcard:'身分証明書',
        upimg:'お手数ですが、証明書をアップロードしてください。第一枚目は正面、第二枚目は裏、第三枚目は手持ち証明書の写真をお送りしてください。',
        submit:'提出',
        auditing:'審査中...',
        certified:'確認済み!',
        pname:'お手数ですが、名前をご入力してください',
        pidcard:'お手数ですが、証明書番号をご入力してください',
        pimg:'お手数ですが、証明書の写真をお送りしてください!',
    },
    // 受取方式
    seting:{
        pmethod:'收款方式',
        truename:'実名',
        opening:'口座名称',
        bank:'銀行カード',
        alipay:'支付宝アカウント',
        wename:'WeChat名前',
        wechat:'WeChat番号',
        pname:'お手数ですが、実名をご記入してください',
        popen:'お手数ですが、口座名称をご記入してください',
        pcard:'お手数ですが、銀行カードをご記入してください',
        palipay:'お手数ですが、支付宝アカウントをご記入してください',
        pwname:'お手数ですが、WeChat名前をご記入してください',
        pwaccount:'お手数ですが、WeChat番号をご記入してください',
        pimg1:'WeChat入金コード',
        pimg2:'アリペイを支払う'
    },
    // ヘルプセンター
    news:{
        seeall:'全てをご覧',
        helpcenter:'ログイン',
        back:'戻る',
		gonggao: '公告する'

    },
    //ようこそ
    login:{
        welcome:'ようこそ',
        phoneLogin:'携帯登録',
        emailLogin:'メールアドレス登録',
        account:'アカウント',
        psw:'パスワード',
        login:'登録する',
        nouser:'まだAzbit-usaのユーザーではありません？',
        goRegister:'すぐ登録すると、世界でリードしているデジタル資産取引プラットフォームで取引を開始できます。',
        registerFree:'無料登録',
        psw6:'パスワードは6位以下ではいけません'
    },
    register:{
        register:'登録',
        phoneRegister:'携帯登録',
        emailRegister:'メールアドレス登録',
        country:'国籍',
        enterPhone:'お手数ですが、携帯番号をご記入してください',
        enterEmail:'お手数ですが、メールアドレスをご入力してください',
        psw16:'パスワードは6 ~ 16位の間でございます',
        inviteCode:'コード',
        sel:'必要とする',
        sel2:'必要でない',
        read:'すでにご覧して同意',
        xieyi:'《ユーザー協議》',
        tips01:'国籍情報登録後は修正不可ですので、必ずきちんと選択して下さい。',
        tips02:'メールの検証が迷惑メールになる可能性がありますので、取り扱いにご注意下さい。',
        tips03:'Azbit-usaのアカウントとログインパスワードをきちんと保管してください。',
        tips04:'他のサイトと同じログインパスワードをご使用しないでください。',
        emailFalse:'入力されたメールアドレスは不規則でございます'
    },
    // 积分兑换
    jc:{
        title:'JC両替デジタル資産ベアプラットフォーム',
        balance:'残高',
        cannum:'使用できるJC数量',
        new:'最新の価格',
        exnum:'交換数 ',
        pnum:'お手数でございますが、JC数量をご入力してください',
        canex:'BEAU交換出来る数量',
        exnow:'すぐに両替する',
        record:'交換記録',
        exprice:'交換価格',
        extime:'交換時間',
        not:'ポイントの数が足りない',
        usenum:'JCの数量を使用する',
        out:'脱退する',
        gotd:'取引に行く'
    }
}



// WEBPACK FOOTER //
// ./src/lang/jp.js